/* ==========================================================================
   journe-mega.js (v14) - image mega menu behaviour. Markup: snippets/mega-menu.liquid.
   Desktop: hover (fine pointers only, 120 ms intent, 200 ms close grace) or
   click/Enter/Space opens; Escape closes and returns focus; rows swap the cards
   instantly, except while the pointer aims at the cards (safe triangle), so
   diagonal mouse travel does not flicker.
   Mobile drawer: category rows slide their cards in; back / close buttons.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 220;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function initDesktop() {
    var item = document.querySelector('[data-jm-item]');
    if (!item) return null;
    var btn = item.querySelector('[data-jm-trigger]');
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    var openT, closeT, hideT, rowT, hoverOpened = false;

    function isOpen() { return btn.getAttribute('aria-expanded') === 'true'; }
    function setOpen(on) {
      clearTimeout(openT); clearTimeout(closeT);
      if (on === isOpen()) return;
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      clearTimeout(hideT);
      if (on) {
        panel.hidden = false;
        void panel.offsetWidth; // commit display:block so the transition runs
        panel.classList.add('is-open');
      } else {
        hoverOpened = false;
        panel.classList.remove('is-open');
        hideT = setTimeout(function () { panel.hidden = true; }, T);
      }
    }
    function show(key) {
      panel.querySelectorAll('[data-jm-pane]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-jm-pane') === key);
      });
      panel.querySelectorAll('[data-jm-key]').forEach(function (r) {
        r.classList.toggle('is-active', r.getAttribute('data-jm-key') === key);
      });
    }

    btn.addEventListener('click', function () {
      // First click after a hover-open keeps it open instead of snapping it shut.
      if (isOpen() && hoverOpened) { hoverOpened = false; return; }
      setOpen(!isOpen());
    });
    item.addEventListener('mouseenter', function () {
      if (!fine.matches) return;
      clearTimeout(closeT);
      if (!isOpen()) openT = setTimeout(function () { setOpen(true); hoverOpened = true; }, 120);
    });
    item.addEventListener('mouseleave', function () {
      if (!fine.matches) return;
      clearTimeout(openT);
      closeT = setTimeout(function () { setOpen(false); }, 200);
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { setOpen(false); btn.focus(); }
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !item.contains(e.relatedTarget)) setOpen(false);
    });
    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) setOpen(false);
    });

    // Safe triangle: while the pointer is heading for the cards, crossing other rows does not
    // swap them; a row only takes over once the pointer moves down the list or rests on it.
    var pts = [], lastCheck, stage = panel.querySelector('.jm-panel__stage');
    function track(e) { pts.push([e.clientX, e.clientY]); if (pts.length > 4) pts.shift(); }
    function aiming() {
      var a = pts[pts.length - 1], p = pts[0];
      if (!a || a === p || a === lastCheck) return false;
      lastCheck = a;
      var r = stage.getBoundingClientRect();
      function slope(q, y) { return (y - q[1]) / ((r.left - q[0]) || 0.01); }
      return a[0] < r.left && slope(a, r.top) < slope(p, r.top) && slope(a, r.bottom) > slope(p, r.bottom);
    }
    function hoverRow(key) {
      clearTimeout(rowT);
      if (aiming()) rowT = setTimeout(function () { hoverRow(key); }, 100);
      else show(key);
    }
    panel.addEventListener('mousemove', track);
    panel.querySelectorAll('[data-jm-key]').forEach(function (row) {
      var key = row.getAttribute('data-jm-key');
      row.addEventListener('mouseenter', function (e) { track(e); hoverRow(key); });
      row.addEventListener('mouseleave', function () { clearTimeout(rowT); });
      row.addEventListener('focus', function () { show(key); });
    });

    return { open: setOpen, show: show };
  }

  function initMobile() {
    var root = document.querySelector('[data-jm-mobile]');
    if (!root) return;
    var drawer = root.closest('.mobile-menu');
    var current = null, opener = null;

    function open(pane, btn) {
      if (drawer) { drawer.scrollTop = 0; drawer.classList.add('jm-drilled'); }
      pane.hidden = false;
      void pane.offsetWidth;
      pane.classList.add('is-active');
      btn.setAttribute('aria-expanded', 'true');
      current = pane; opener = btn;
      var back = pane.querySelector('[data-jm-back]');
      back && back.focus({ preventScroll: true });
    }
    function back(instant) {
      if (!current) return;
      var pane = current;
      current = null;
      pane.classList.remove('is-active');
      drawer && drawer.classList.remove('jm-drilled');
      opener.setAttribute('aria-expanded', 'false');
      if (instant || !T) pane.hidden = true;
      else setTimeout(function () { if (pane !== current) pane.hidden = true; }, T);
      if (!instant) opener.focus({ preventScroll: true });
    }

    root.querySelectorAll('[data-jm-open]').forEach(function (btn) {
      var pane = document.getElementById(btn.getAttribute('aria-controls'));
      if (!pane) return;
      // Unhide on press so the lazy images start loading before the slide-in.
      btn.addEventListener('pointerdown', function () { pane.hidden = false; });
      btn.addEventListener('click', function () { open(pane, btn); });
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-jm-back]')) back(false);
      if (e.target.closest('[data-jm-close]')) {
        back(true);
        var close = document.getElementById('MobileMenuClose');
        close && close.click();
      }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && current) { e.stopPropagation(); back(false); }
    });
    var toggle = document.getElementById('MobileMenuToggle');
    toggle && toggle.addEventListener('click', function () { back(true); });
  }

  // v18 perf: both menu copies ship inside <template>, so neither sits in the DOM (or
  // downloads images) until it can be used: desktop on idle or first approach, mobile on
  // first drawer open. Saves ~600 elements on every page load.
  function hydrate(kind) {
    var t = document.querySelector('template[data-jm-tpl="' + kind + '"]');
    if (!t) return false;
    t.replaceWith(t.content.cloneNode(true));
    return true;
  }
  var desk = null;
  function ensureDesktop() { if (hydrate('desktop')) desk = initDesktop(); return desk; }
  function ensureMobile() { if (hydrate('mobile')) initMobile(); }
  var item = document.querySelector('[data-jm-item]');
  if (item) {
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { item.addEventListener(ev, ensureDesktop, { once: true, passive: true }); });
    item.addEventListener('click', function (e) {
      if (!desk && e.target.closest('[data-jm-trigger]')) { ensureDesktop() && desk.open(true); }
    }, { once: true });
  }
  if (window.matchMedia('(min-width: 901px)').matches) {
    (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(ensureDesktop);
  }
  var mToggle = document.getElementById('MobileMenuToggle');
  mToggle && mToggle.addEventListener('pointerdown', ensureMobile, { once: true, passive: true });
  mToggle && mToggle.addEventListener('click', ensureMobile, { once: true });

  // Theme editor: selecting a category block opens the panel on that category.
  document.addEventListener('shopify:block:select', function (e) {
    var key = e.target && e.target.getAttribute && e.target.getAttribute('data-jm-key');
    ensureDesktop(); if (desk && key) { desk.open(true); desk.show(key); }
  });
  document.addEventListener('shopify:section:load', function () { hydrate('desktop'); hydrate('mobile'); desk = initDesktop(); initMobile(); });
})();
